<template>
  <SimpleDataWithVariation
    :title="title"
    :item-id="itemId"
    :value="value"
    :variation="variation"
    :raw-variation="rawVariation"
    :request-status="requestStatus"
    :comparation-value="comparationValue"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import SimpleDataWithVariation from '@/components/cards/models/SimpleDataWithVariation';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';
import { calculateVariation } from '@/utils/math';
import blipModel from '@/mixins/blip-model';

export default {
  name: 'BlipRejectionRate',
  components: {
    SimpleDataWithVariation,
  },
  mixins: [
    blipModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    servicePath: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      value: '',
      variation: '',
      rawVariation: '',
      comparationValue: '',
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getBlipServiceWithVariation',
      'hasNoBlipBotAndContractFiltered',
      'getAppliedCardFilter',
    ]),
    async getData(options) {
      const appliedCardFilter = await this.getAppliedCardFilter(this.itemId);

      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      if (await this.hasNoBlipBotAndContractFiltered(this.itemId)) {
        this.requestStatus = 'emptyBot';
        return;
      }

      if (!this.isSingleBotSelected(appliedCardFilter)) {
        this.requestStatus = 'supportsOnlyOneBot';
        return;
      }

      this.getBlipServiceWithVariation({
        servicePath: this.servicePath,
        itemId: this.itemId,
      })
        .then((response) => {
          const previousData = this.returnBlipSingleBotResponse(response.previousData);
          const currentData = this.returnBlipSingleBotResponse(response.currentData);

          const previousValue = previousData.resource.rejectionRate;
          const currentValue = currentData.resource.rejectionRate;

          if (currentValue === 'Infinity' || previousValue === 'Infinity') {
            this.value = '-%';
            this.variation = 0;
            this.rawVariation = 0;
            this.comparationValue = 0;
          } else {
            const variation = calculateVariation(previousValue, currentValue);
            this.value = this.formatPercentage(currentValue);
            this.variation = variation;
            this.rawVariation = variation;
            this.comparationValue = this.formatPercentage(previousValue);
          }

          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = error.message;
        });
    },
    formatPercentage(value) {
      return Intl.NumberFormat('pt-br', {
        style: 'percent',
        maximumFractionDigits: 2,
      }).format(value);
    },
  },
};
</script>

